/* eslint no-unused-vars: 0 */
import BootstrapMVCForm from '../misc/bootstrap-mvcform';
import BooklistPage from '../controllers/booklist';
import NewBooklistPage from '../controllers/page/booklist';
import ProductPage from '../controllers/product';

const form = document.querySelector('#booklist-form');

if (window.UseNewBooklistScript) {
    const newBooklistPage = new NewBooklistPage(
        window.BookListPage_StudentDiscountUrl,
        window.BookListPage_LinkCartUrl,
        window.BookListPage_Language,
        window.BookListPage_MembershipIsVisble,
        window.BookListPage_urlRouteMembershipChange,
        window.BookListPage_membershipFee
    );
} else {
    const booklistPage = new BooklistPage(
        window.BookListPage_StudentDiscountUrl,
        window.BookListPage_LinkCartUrl,
        window.BookListPage_Language,
        window.BookListPage_MembershipIsVisble,
        window.BookListPage_urlRouteMembershipChange,
        window.BookListPage_membershipFee
    );
}

const contactForm = new BootstrapMVCForm($('#booklist-form'));

$(() => {
    if (window.showSchoolWillOrderNotification) {
        $('#schoolorder-notification-modal').on('hidden.bs.modal', function (e) {
            document.location.href = "/";
        });
        $('#schoolorder-notification-modal').modal('show');
    }

    if (window.showBooklistPurchaseNotification) {
        $('#booklist-purchase-notification-modal').modal('show');
    }

    if (window.showLoginNotification) {
        $('#login-notification-modal').modal('show');
    }

    // Initialize tooltips
    $('[data-toggle="tooltip"]').tooltip();
});